import TextUtils from "./TextUtils";
class Markup {
	static countElements(content, el) {
		if (!content || !el) {
			return 0;
		}
		const markup = document.createElement('div');
		markup.innerHTML = content;
		const elements = markup.querySelectorAll(el);
		return elements.length;
	}

	static createMarkupEl(content) {
		const markup = document.createElement('div');
		markup.innerHTML = content;
		return markup;
	}

	static stripTags(markup) {
		const el = this.createMarkupEl(markup);
		return el.textContent;
	}

	static removeEmptyLines(markup) {
		const tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];
		tags.forEach((tagName) => {
			markup = markup.replaceAll(`<${tagName}><br></${tagName}>`, '').replaceAll(`<${tagName}></${tagName}>`, '');
		});
		return markup;
	}

	static cleanResourceLinks(markup) {
		if (!markup) {
			return '';
		}
		markup = markup.replace(/<link[^>]*>/g,"");
		markup = markup.replace(/<video[^>]*>/g,"");
		if (markup.indexOf('<script') !== -1) {
			markup = markup.replaceAll(/<script([\S\s]*?)>([\S\s]*?)<\/script>/gi, '');
		}
		if (markup.indexOf('<style') !== -1) {
			markup = markup.replaceAll(/<style([\S\s]*?)>([\S\s]*?)<\/style>/gi, '');
		}
		if (markup.indexOf('<svg') !== -1) {
			markup = markup.replaceAll(/<svg([\S\s]*?)>([\S\s]*?)<\/svg>/gi, '');
		}
		if (markup.indexOf('<use') !== -1) {
			markup = markup.replaceAll(/<use([\S\s]*?)>([\S\s]*?)<\/use>/gi, '');
		}
		markup = markup.replace(/style\s*=\s*['"](.*?)['"]/gi, '');
		markup = markup.replace(/style=['"][a-zA-Z0-9\s:_#;,'"()-]*['"]/gi, '');
		markup = markup.replace(/\s+src\s*=/gi, ' data-src=');
		markup = markup.replace(/\s+srcset\s*=/gi, ' data-srcset=');
		return markup;
	}

	static cleanContent(markup, allowed = []) {
		if (!markup) {
			return '';
		}

		markup = this.cleanResourceLinks(markup);

		let body = this.createMarkupEl(markup);
		let lists = body.querySelectorAll('ol, ul');
		if (lists.length) {
			lists.forEach((list) => {
				let links = list.querySelectorAll('a');
				let items = list.querySelectorAll('li');

				if (!links || !items) {
					return;
				}

				let linkText = [];
				links.forEach((link) => {
					let text = link.textContent.trim().replaceAll(/\n/g, '').replaceAll(/\t/g, '');
					if (text) {
						linkText.push(text);
					}
				});
				let itemText = [];
				items.forEach((item) => {
					let text = item.textContent.trim().replaceAll(/\n/g, '').replaceAll(/\t/g, '');
					if (text) {
						itemText.push(text);
					}
				});

				if (linkText.join() === itemText.join()) {
					list.remove();
				}
			});
		}
		let unwantedSelectors = ['center', 'object', 'svg', 'aside', '*:empty', 'noscript', 'style', 'script', 'img', 'video', 'iframe', 'embed', 'footer', 'nav', '.advertisement', '.ad', '.adv', 'canvas', 'font', 'form', 'input', 'textarea', 'select', 'label'];
		let selectors = unwantedSelectors.filter((el) => !allowed.includes(el));
		const unwanted = body.querySelectorAll(selectors.join(', '));
		unwanted.forEach((el) => el.remove());

		body.innerHTML = body.innerHTML
			.replaceAll('&nbsp;', ' ')
			.replaceAll('\n', '')
			.replaceAll('\t', '')
			.replaceAll(/class="[a-zA-Z0-9_\s-]*"/gi, '')
			.replaceAll(/id="[a-zA-Z0-9_\s-]*"/gi, '')
			.replaceAll(/target="[a-zA-Z0-9_\s-]*"/gi, '')
			.replaceAll(/role="[a-zA-Z0-9_\s-]*"/gi, '')
			.replaceAll(/rel="[a-zA-Z0-9_\s-]*"/g, '')
			.replaceAll(/align="[a-zA-Z]*"/gi, '')
			.replaceAll(/itemscope="[a-zA-Z0-9.:_\s-]*"/g, '')
			.replaceAll(/itemtype="[a-zA-Z0-9.:_/\s-]*"/g, '')
			.replaceAll(/itemprop="[a-zA-Z0-9.:_/\s-]*"/g, '')
			.replaceAll(/data-[a-z-]+="[a-zA-Z0-9_\s-]*"/gi, '')
			.replaceAll(/aria-[a-z-]+="[a-zA-Z0-9_\s-]*"/gi, '')
			.replaceAll(/style="[a-zA-Z0-9\s:_#;,'"()-]*"/gi, '')
			.replaceAll(/<!--[a-zA-Z0-9!@#$%&*();:,_=+\s-]*-->/g, '')
			.replaceAll(/<span[^>]*>/gi, '')
			.replaceAll(/<\/span[^>]*>/gi, '')
			.replaceAll(/<div[^>]*>/gi, '')
			.replaceAll(/<\/div[^>]*>/gi, '')
			.replaceAll(/\s\s+/g, ' ')
			.replaceAll(/<[a-z]+[^>]*>\s*<\/[a-z]+>/gi, '')
			.replaceAll(/<[a-zA-Z0-9]+>\s*<\/[a-zA-Z0-9]+>/g, '')
			.replaceAll(/<!--(.*?)-->/g, '' );
		return body.innerHTML;
	}

	static isPhraseInAnyElement(phrase, postContent, selector) {
		if (!phrase || !postContent || !selector) {
			return false;
		}

		var result = false;
		const markup = this.createMarkupEl(postContent);

		const elements = markup.querySelectorAll(selector);
		if (!elements) {
			return false;
		}
		elements.forEach((el) => {
			if (TextUtils.isPhraseInText(phrase, el.textContent)) {
				result = true;
			}
		});

		return result;
	}
}

export default Markup;